export default "__VITE_ASSET__7izt1STg__"